import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { AdminPageHeader } from '../Common/AdminPagesHeader';
import { SCORECARD_REPORT, SCORE_CARD_COLUMNS_ADMIN, QUERY_KEYS } from '../../../constants';
import { Table } from '../../shared';
import { usePagination } from '../../../hooks';
import { getAllScoreCardDetails, popup } from '../../../utils';
import EditScorecardModal from './ScoreCardModal';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const ScoreCardReportAdmin = () => {
    const location = useLocation();
    const { state } = location;

    const [response, setResponse] = useState({ data: [], count: 0 });
    const [search, setSearch] = useState('');
    const [platformGrade, setPlatformGrade] = useState(state?.accountUserDetails?.grade || 'grey');
    const pagination = usePagination(response.data.length, response.count);
    const [openEditModal, setOpenEditModal] = useState(false);

    const handleAddClick = () => {
        setOpenEditModal(true);
    };

    const [debouncedSearch] = useDebouncedValue(search, 500);
    const { data, isFetched, isFetching, isError, error } = useQuery({
        queryKey: [
            QUERY_KEYS.SCORECARD_DETAILS,
            debouncedSearch,
            state?.accountUserDetails?.id,
            state?.accountUserDetails?.platform_id,
            pagination.offset,
            pagination.limit,
        ],
        queryFn: async () =>
            await getAllScoreCardDetails({
                account_id: state?.accountUserDetails?.id,
                offset: pagination.offset,
                limit: pagination.limit,
                search: debouncedSearch,
                selectedPlatform: { id: state?.accountUserDetails?.platform_id },
            }),
        enabled:
            Boolean(state?.accountUserDetails?.id) &&
            Boolean(state?.accountUserDetails?.platform_id),
        select: (data) => ({ data: data.data, count: data.count }),
    });
    if (isError) popup('error', error.message);

    useEffect(() => {
        if (data && isFetched && !!state?.accountUserDetails?.grade) {
            setResponse(data);
            setPlatformGrade(
                data.data[0]?.platform_grade
                    ? data.data[0]?.platform_grade
                    : state?.accountUserDetails?.grade || 'grey',
            );
        }
    }, [data, isFetched, state?.accountUserDetails?.grade]);

    return (
        <>
            <AdminPageHeader
                accountUserDetails={{ ...state?.accountUserDetails, grade: platformGrade }}
                heading={SCORECARD_REPORT.PAGE_HEADING}
                buttonText={SCORECARD_REPORT.BUTTON_TEXT}
                searchBarPlaceholder={SCORECARD_REPORT.SEARCH_BAR_PLACEHOLDER}
                setSearch={setSearch}
                count={pagination.dataCount}
                showAddButton
                adminScoreCard
                backbutton
                setResponse={setResponse}
                handleAddClick={handleAddClick}
                AddModal={
                    openEditModal ? (
                        <EditScorecardModal
                            accountDetails={{ ...state?.accountUserDetails, grade: platformGrade }}
                            selectedPlatform={{ id: state?.accountUserDetails?.platform_id }}
                            openEditModal={openEditModal}
                            setOpenEditModal={setOpenEditModal}
                            isEdit={false}
                            setResponse={setResponse}
                            scorecards={response?.data}
                        />
                    ) : (
                        ''
                    )
                }
                setCurrentPage={pagination.setCurrentPage}
                showGradeButton
            />
            <Table
                columns={SCORE_CARD_COLUMNS_ADMIN}
                data={response.data}
                pagination={pagination}
                pageName={SCORECARD_REPORT.PAGE_NAME}
                stickyColumns={['Hiring Client']}
                isLoading={isFetching}
            />
        </>
    );
};
